import { createAsyncAction } from 'typesafe-actions';
import { APIError } from '../../types/errors';
import { Contact } from './payload';

export const getContacts = createAsyncAction(
    'GET_CONTACTS',
    'GET_CONTACTS_SUCCESSES',
    'GET_CONTACTS_FAILED',
)<undefined, Contact[], APIError>();